module.exports = __webpack_public_path__ + "static/media/wallpaper.1c62f479.jpg";